import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import './scss/time.scss';


import Color from '@tool/color';
import moTime from './store/time';
import TimeChart from './component/time-chart';
import Empty from '@/component/empty';
import TimeIncomeChart from './component/time-income-chart';
import MainTitle from '../component/main-title';
import URI from 'urijs';
import Sub from '../component/sub';
import moMenu from '@/page/effect/store/menu';

interface IProps { }
interface IState { }

const Time = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { timeList } = moTime;
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);

  const emen: any = {
    多指标: 'multi_indicator',
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };

  const showList = (val: string) => {
    const active = emen[val];
    let list: any = [];
    if (timeList) {
      list = timeList[active]?.overview;
    }
    return list;
  };

  const xData = useMemo(() => {
    const xList: any = [];
    const costList: any = [];
    const profitList: any = [];
    const revenueList: any = [];
    timeList?.multi_indicator?.detail?.forEach((res: any) => {
      xList.push(res.label);
      costList.push(res.cost_per_staff_ratio);
      profitList.push(res.profit_per_staff_ratio);
      revenueList.push(res.revenue_per_staff_ratio);
    });
    return {
      xList, costList, profitList, revenueList,
    };
  }, [timeList]);

  const xcData = (val: string) => {
    const active = emen[val];
    const xList: any = [];
    const listp25: any = [];
    const listp50: any = [];
    const listp75: any = [];
    const listp50Ratio: any = [];
    if (timeList) {
      timeList[active]?.detail?.forEach((res: any) => {
        xList.push(res.label);
        listp25.push(res.p25);
        listp50.push(res.p50);
        listp75.push(res.p75);
        listp50Ratio.push(res.p50_ratio);
      });
    }
    return {
      xList, listp25, listp50, listp50Ratio, listp75,
    };
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect02" className="effect-time-warp-pdf human-common-pdf">
      <MainTitle
        title='时间趋势'
        subtitle={moMenu.industryName}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />
      {data.tabList?.b1 && <section>
        <Sub title='多指标' />
        <section className="chart-demo">
          {(xData?.costList?.filter((res: any) => res).length > 0 ||
            xData.profitList.filter((res: any) => res).length > 0 ||
            xData.revenueList.filter((res: any) => res).length > 0
          ) ?
            <TimeChart /> : <Empty />}
        </section>
        {!isEmpty(showList('多指标')) && <section className="chart-detail industry-detail">
          {
            showList('多指标')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.b2 && <section>
        <Sub title='人均营业收入' />
        {
          (xcData('人均营业收入')?.listp25?.filter((res: any) => res).length > 0 ||
            xcData('人均营业收入')?.listp50?.filter((res: any) => res).length > 0 ||
            xcData('人均营业收入')?.listp75?.filter((res: any) => res).length > 0 ||
            xcData('人均营业收入')?.listp50Ratio?.filter((res: any) => res).length > 0
          ) ? <TimeIncomeChart activeTab='人均营业收入' /> : <Empty />
        }
        {!isEmpty(showList('人均营业收入')) && <section className="chart-detail industry-detail">
          {
            showList('人均营业收入')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.b3 && <section>
        <Sub title='人均净利润' />
        {
          (xcData('人均净利润')?.listp25?.filter((res: any) => res).length > 0 ||
            xcData('人均净利润')?.listp50?.filter((res: any) => res).length > 0 ||
            xcData('人均净利润')?.listp75?.filter((res: any) => res).length > 0 ||
            xcData('人均净利润')?.listp50Ratio?.filter((res: any) => res).length > 0
          ) ? <TimeIncomeChart activeTab='人均净利润' /> : <Empty />
        }
        {!isEmpty(showList('人均净利润')) && <section className="chart-detail industry-detail">
          {
            showList('人均净利润')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.b4 && <section>
        <Sub title='人均薪酬成本' />
        {
          (xcData('人均薪酬成本')?.listp25?.filter((res: any) => res).length > 0 ||
            xcData('人均薪酬成本')?.listp50?.filter((res: any) => res).length > 0 ||
            xcData('人均薪酬成本')?.listp75?.filter((res: any) => res).length > 0 ||
            xcData('人均薪酬成本')?.listp50Ratio?.filter((res: any) => res).length > 0
          ) ? <TimeIncomeChart activeTab='人均薪酬成本' /> : <Empty />
        }
        {!isEmpty(showList('人均薪酬成本')) && <section className="chart-detail industry-detail">
          {
            showList('人均薪酬成本')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.b5 && <section>
        <Sub title='元均营业收入' />
        {
          (xcData('元均营业收入')?.listp25?.filter((res: any) => res).length > 0 ||
            xcData('元均营业收入')?.listp50?.filter((res: any) => res).length > 0 ||
            xcData('元均营业收入')?.listp75?.filter((res: any) => res).length > 0 ||
            xcData('元均营业收入')?.listp50Ratio?.filter((res: any) => res).length > 0
          ) ? <TimeIncomeChart activeTab='元均营业收入' /> : <Empty />
        }
        {!isEmpty(showList('元均营业收入')) && <section className="chart-detail industry-detail">
          {
            showList('元均营业收入')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.b6 && <section>
        <Sub title='元均净利润' />
        {
          (xcData('元均净利润')?.listp25?.filter((res: any) => res).length > 0 ||
            xcData('元均净利润')?.listp50?.filter((res: any) => res).length > 0 ||
            xcData('元均净利润')?.listp75?.filter((res: any) => res).length > 0 ||
            xcData('元均净利润')?.listp50Ratio?.filter((res: any) => res).length > 0
          ) ? <TimeIncomeChart activeTab='元均净利润' /> : <Empty />
        }
        {!isEmpty(showList('元均净利润')) && <section className="chart-detail industry-detail">
          {
            showList('元均净利润')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

    </section>
  );
};

export default observer(Time);
